export default __webpack_public_path__ + "static/media/589.3085cc16.gif";